import { Reducer } from 'redux';

import { BouncedSummaryTypes, StatisticsState } from './types';

const defaultState = {
    summaryLoading: false,
    todaySummaryLoading: false,
    linktrackingLoading: false,
    linkTrackingActivePage: 1,
    linkContactsActivePage: 1,
    linkTrackingPerPage: 25,
    linkContactsPerPage: 25,
};

const reducer: Reducer<StatisticsState> = (state: StatisticsState = defaultState, action): StatisticsState => {
    const { payload, type } = action;
    switch (type) {
        case '@@statistics/LOADSUMMARY_FETCH_START':
        case '@@statistics/LOADSUMMARY_FETCH_ERROR':
            return {
                ...state,
                summaryLoading: payload.summaryLoading,
            };
        case '@@statistics/LOADSUMMARY_FETCH_SUCCESS':
            return {
                ...state,
                summaryLoading: payload.summaryLoading,
                summary: payload.summary,
            };
        case '@@statistics/LOADTODAYSUMMARY_FETCH_START':
        case '@@statistics/LOADTODAYSUMMARY_FETCH_ERROR':
            return {
                ...state,
                todaySummaryLoading: payload.todaySummaryLoading,
            };
        case '@@statistics/LOADTODAYSUMMARY_FETCH_SUCCESS':
            return {
                ...state,
                todaySummaryLoading: payload.todaySummaryLoading,
                todaySummary: payload.todaySummary,
            };
        case '@@statistics/LOADLINKTRACKING_START':
        case '@@statistics/LOADLINKTRACKING_SUCCESS':
        case '@@statistics/LOADLINKTRACKING_ERROR':
        case '@@statistics/LINKTRACKING_SEARCH':
        case '@@statistics/LINKCONTACTS_START':
        case '@@statistics/LINKCONTACTS_SUCCESS':
        case '@@statistics/LINKCONTACTS_ERROR':
        case BouncedSummaryTypes.SUCCESS:
            return {
                ...state,
                ...payload,
            };
        case '@@statistics/EXPORT_LINKS':
        case '@@statistics/EXPORT_LINKS_START':
        case '@@statistics/EXPORT_LINKS_SUCCESS':
        case '@@statistics/EXPORT_LINKS_ERROR':
        case '@@statistics/EXPORT_LINKCONTACTS':
        case '@@statistics/EXPORT_LINKCONTACTS_START':
        case '@@statistics/EXPORT_LINKCONTACTS_SUCCESS':
        case '@@statistics/EXPORT_LINKCONTACTS_ERROR':
        default:
            return state;
    }
};

export { reducer as statistics };

export default reducer;
